/**
 * Chip-based watchlist editor. Add symbols via text input, remove via chip delete.
 */

import React, { useState } from 'react';
import { Box, Chip, TextField, Typography } from '@mui/material';

interface Props {
  symbols: string[];
  onChange: (symbols: string[]) => void;
}

const WatchlistEditor: React.FC<Props> = ({ symbols, onChange }) => {
  const [input, setInput] = useState('');

  const handleAdd = () => {
    const sym = input.trim().toUpperCase();
    if (sym && !symbols.includes(sym)) {
      onChange([...symbols, sym]);
    }
    setInput('');
  };

  const handleRemove = (sym: string) => {
    onChange(symbols.filter((s) => s !== sym));
  };

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Watchlist ({symbols.length} symbols)
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
        {symbols.map((sym) => (
          <Chip
            key={sym}
            label={sym}
            size="small"
            onDelete={() => handleRemove(sym)}
            variant="outlined"
          />
        ))}
      </Box>
      <TextField
        size="small"
        placeholder="Add symbol..."
        value={input}
        onChange={(e) => setInput(e.target.value.toUpperCase())}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleAdd();
          }
        }}
        sx={{ width: 150 }}
      />
    </Box>
  );
};

export default WatchlistEditor;
